/*
 * Capable Health API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0.3
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.72
 *
 * Do not edit the class manually.
 *
 */
import ApiClient from '../ApiClient';
import TrustCommercesubscriptionsSubscription from './TrustCommercesubscriptionsSubscription';

/**
 * The TrustCommerceSubscriptionsBody model module.
 * @module model/TrustCommerceSubscriptionsBody
 * @version v0.3
 */
export default class TrustCommerceSubscriptionsBody {
  /**
   * Constructs a new <code>TrustCommerceSubscriptionsBody</code>.
   * @alias module:model/TrustCommerceSubscriptionsBody
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>TrustCommerceSubscriptionsBody</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/TrustCommerceSubscriptionsBody} obj Optional instance to populate.
   * @return {module:model/TrustCommerceSubscriptionsBody} The populated <code>TrustCommerceSubscriptionsBody</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new TrustCommerceSubscriptionsBody();
      if (data.hasOwnProperty('subscription'))
        obj.subscription = TrustCommercesubscriptionsSubscription.constructFromObject(data['subscription']);
    }
    return obj;
  }
}

/**
 * @member {module:model/TrustCommercesubscriptionsSubscription} subscription
 */
TrustCommerceSubscriptionsBody.prototype.subscription = undefined;

